import { useNavigate } from 'react-router-dom';

import noCamerasPng from '@/assets/illustrations/empty/no-cameras.png';
import { useUserProfileStore } from '@/stores/user-profile-store';
import { UpsellSheet } from '@/components/common/UpsellSheet';
import { UPSELL_COPY } from '@/constants/upsell-copy';
import { OperationalGuide } from '@/components/common/OperationalGuide';

export function CamerasPage() {
  const isPro = useUserProfileStore((s) => s.isPro);
  const navigate = useNavigate();

  if (!isPro()) {
    return (
      <UpsellSheet
        featureName={UPSELL_COPY.cell_cameras.featureName}
        description={UPSELL_COPY.cell_cameras.description}
        featureGate="cell_cameras"
        onDismiss={() => navigate(-1)}
      />
    );
  }

  return (
    <div data-testid="cameras-page">
      <OperationalGuide
        illustration={noCamerasPng}
        heading="No Cameras Set Up"
        subtext="Add your first trail camera to start monitoring your land"
        data-guide-id="cameras-empty"
      />
    </div>
  );
}
